import React, { Fragment, useEffect, useState } from "react";
import {
  Outlet,
  Link,
  NavLink,
  useLocation,
  useNavigate,
} from "react-router-dom";

import { Zoom } from "react-awesome-reveal";

import { useDispatch, useSelector } from "react-redux";
import { error } from "jquery";
import { Alert, Snackbar, Tooltip, useMediaQuery } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faGlobeAfrica,
  faHeadset,
  faHome,
  faLocationDot,
  faMapLocationDot,
  faMoneyBill,
  faPhone,
  faQuestionCircle,
  faRoute,
  faSignsPost,
  faStar,
  faUser,
  faX,
} from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import { setLanguage } from "../data/languageSlice";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faSquareInstagram,
  faSquareXTwitter,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
// import { fetchLayout } from "../data/layoutSlice";
import Loader from "./../Loader";

const HomeLayout = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(min-width:768px) and (max-width:1023px)");
  const isDesktop = useMediaQuery("(min-width:1024px)");
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const [showButton, setShowButton] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const chainCode = queryParams.get("chainCode");
  const dispatch = useDispatch();
  const language = useSelector((state) => state.language.language);
  const { configuration, loading } = useSelector(
    (state) => state.configuration
  );
  // const { layoutData, loading, error } = useSelector(
  //   (state) => state.layoutData
  // );
  const [scrolled, setScrolled] = useState(false);
  // useEffect(() => {
  //   dispatch(fetchLayout());
  // }, [dispatch]);

  useEffect(() => {
    const checkScroll = () => {
      // Convert 70vh to pixels
      const triggerHeight = window.innerHeight * 0.2;
      const triggerHeight2 = window.innerHeight * 0.1;

      if (window.scrollY > triggerHeight) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
      if (window.scrollY > triggerHeight2) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    // Add event listener
    window.addEventListener("scroll", checkScroll);

    // Clean up the event listener
    return () => {
      window.removeEventListener("scroll", checkScroll);
    };
  }, []);
  const [isVisible, setIsVisible] = useState(false);
  const [view1, setView1] = useState(false);
  const [view2, setView2] = useState(false);
  const [view3, setView3] = useState(false);
  // Function to handle the scroll to top action
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Function to check scroll position
  const checkScrollTop = () => {
    if (!isVisible && window.pageYOffset > 400) {
      setIsVisible(true);
    } else if (isVisible && window.pageYOffset <= 400) {
      setIsVisible(false);
    }
  };

  // Listen for scroll events
  useEffect(() => {
    window.addEventListener("scroll", checkScrollTop);
    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  });
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  // const { loadingNewsletter, errorNewsletter } = useSelector(
  //   (state) => state.newsLetter
  // );
  const [isOpen, setIsOpen] = useState(false);

  // Function to toggle the menu open and closed
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const [email, setEmail] = useState("");

  const [open, setOpen] = React.useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };
  const toggleLanguage = () => {
    const newLanguage = language === "en" ? "ar" : "en";
    dispatch(setLanguage(newLanguage));
    window.location.pathname = `/${newLanguage}${window.location.pathname.substring(
      3
    )}`;
  };

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  const [isSticky, setIsSticky] = useState(false);

  const handleScroll = () => {
    // Check if the window's scroll position is greater than a certain value (e.g., 50px)
    if (window.scrollY > 50) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  useEffect(() => {
    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const [viewCurrency, setViewCurrency] = useState(true);
  const [viewLanguage, setViewLanguage] = useState(true);

  // mobile menu
  const [isMenuActive, setIsMenuActive] = useState(false);

  // Toggle menu handler
  const handleMenuToggle = () => {
    setIsMenuActive(!isMenuActive);
  };
  const [isDestinationsActive, setIsDestinationsActive] = useState(false);

  const handleDestinationsClick = (e) => {
    e.preventDefault();
    setIsDestinationsActive(!isDestinationsActive);
  };
  const [activeTab, setActiveTab] = useState(1); // Default to the first tab

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div
            className={`langMenu  js-langMenu ${viewLanguage && "is-hidden"}`}
          >
            <div
              className="langMenu__bg"
              onClick={() => setViewLanguage(true)}
            ></div>

            <div className="langMenu__content bg-white rounded-4">
              <div className="d-flex items-center justify-between px-30 py-20 sm:px-15 border-bottom-light">
                <div className="text-20 fw-500 lh-15">
                  Select your language{" "}
                </div>
                <button
                  className="pointer"
                  onClick={() => setViewLanguage(true)}
                >
                  <i className="icon-close"></i>
                </button>
              </div>

              <div className="modalGrid px-30 py-30 sm:px-15 sm:py-15">
                <div className="modalGrid__item js-item">
                  <div className="py-10 px-15 sm:px-5 sm:py-5">
                    <div className="text-15 lh-15 fw-500 text-dark-1">
                      <img
                        src="/titsolutions/img/general/lang.png"
                        width="16"
                        height="16"
                        loading="lazy"
                        alt="Language"
                        className="rounded-full mr-10"
                      />
                      English{" "}
                    </div>
                    <div className="text-14 lh-15 mt-5 js-title">
                      United States{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <header
            className={`header mt-10 -type-9 js-header ${
              isSticky ? "bg-dark-1 is-sticky" : ""
            }`}
          >
            <div className="header__container container">
              <div className="row justify-between items-center ">
                <div className="col-auto">
                  <div className="d-flex items-center">
                    <Link
                      to={`/?lang=en&chainCode=${chainCode}`}
                      className="header-logo mr-20"
                      data-x="header-logo"
                      data-x-toggle="is-logo-dark"
                    >
                      <img
                        src={`${
                          configuration?.companyLogo !==
                          "https://cdn.nilecabins.info/images/uploads/"
                            ? configuration?.companyLogo
                            : "nilecabinscomwhite.png"
                        }`}
                        alt="logo icon"
                      />
                    </Link>
                  </div>
                </div>

                <div className="col-auto">
                  <div className="d-flex items-center">
                    {/* <div className="col-auto">
                  <div className="row x-gap-15 items-center jusify-between">
                    <div className="col-auto">
                      <div className="row x-gap-20 items-center ">
                        <div className="col-auto   ">
                          <button
                            className="d-flex items-center text-14 text-white"
                            data-x-click="currency"
                            onClick={() => setViewCurrency(!viewCurrency)}
                          >
                            <span className="js-currencyMenu-mainTitle">
                              <FontAwesomeIcon icon={faMoneyBill} /> USD{" "}
                            </span>
                            <i className="icon-chevron-sm-down text-7 ml-10"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                    <div
                      className={`x-gap-20 items-center pl-20  ${
                        window.location.pathname.includes("/booking") ||
                        window.location.pathname.includes("/contact-us") ||
                        window.location.pathname.includes("/checkout") ||
                        window.location.pathname.includes("/add-extra") ||
                        window.location.pathname.includes("/help-center") ||
                        window.location.pathname.includes("/signup") ||
                        window.location.pathname.includes("/signin") ||
                        window.location.pathname.includes("/cruise-type") ||
                        window.location.pathname.includes("/cruises-details")
                          ? "text-primary"
                          : "text-white"
                      }`}
                      data-x="header-mobile-icons"
                      data-x-toggle="text-white"
                    >
                      <div>
                        <div className="col-auto  ">
                          <button
                            className="items-center text-14  "
                            onClick={() => setViewLanguage(!viewLanguage)}
                          >
                            <img
                              src="/titsolutions/img/general/lang.png"
                              width="16"
                              height="16"
                              loading="lazy"
                              alt="Language"
                              className="rounded-full mr-10"
                            />
                            <span className="js-language-mainTitle">EN </span>
                            <i className="icon-chevron-sm-down text-7 ml-15"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <Outlet />
        </>
      )}
    </>
  );
};

export default HomeLayout;
